import {gtmEvent, loggedOutSegment, segment} from './helpers'

export const headerCreateEventClicked = () => segment('Clicked Create Event Header Button')

export const headerGetStartedClicked = () => {
  gtmEvent('headerGetStarted')
  loggedOutSegment('Clicked Get Started Header Button')
}

export const headerHelpLinkClicked = () => segment('Clicked Help Header Link')

export const headerLocationsLinkClicked = () => loggedOutSegment('Clicked Locations Header Link')

export const headerLoginLinkClicked = () => loggedOutSegment('Clicked Login Header Link')

export const headerNavClicked = (targetLinkName, targetLinkUrl) =>
  segment('Clicked Header Link', {
    targetLinkName,
    targetLinkUrl,
    currentPath: window.location.pathname,
  })
